import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Stack, Button, Text, Center, Group, Box } from '@mantine/core';
import { Constants, colors, fontSize } from '../constants';
import backButton from '../images/ui_buttons/back_button.png';
import imgEng from '../images/ui_buttons/style_english.png';
import imgFor from '../images/ui_buttons/style_formal.png';
import imgTro from '../images/ui_buttons/style_tropical.png';
import imgWW from '../images/ui_buttons/style_waterwise.png';

const { white } = colors;

const StyleSelectorMobile = ({
	// State
	selectedStyle,
	
	// Handle functions
	handleBack,
	handleSelectStyle
}) => {
	const styleOptions = [
		{ id: 'english', name: 'English', image: imgEng },
		{ id: 'formal', name: 'Formal', image: imgFor },
		{ id: 'tropical', name: 'Tropical', image: imgTro },
		{ id: 'waterwise', name: 'Waterwise', image: imgWW },
	];

	return (
		<Box style={{ 
			height: '100vh', 
			width: '100vw',
			display: 'flex', 
			flexDirection: 'column',
			backgroundColor: colors.mobileBackground,
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			overflow: 'hidden',
			boxSizing: 'border-box'
		}}>

			{/* Header */}
			<Box style={{
				backgroundColor: colors.backgroundLight,
				height: '120px',
				padding: '10px 10px',
				zIndex: 10,
				position: 'relative',
				borderBottom: `12px solid ${colors.white}`,
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'flex-end',
				alignItems: 'center'
			}}>
				<Text style={{
					color: white,
					fontSize: fontSize.xxxl,
					fontWeight: 'bold',
					textAlign: 'center'
				}}>
					Choose your Garden Style
				</Text>
			</Box>

			{/* Navigation Bar */}
			<Group justify="space-between" align="center" style={{ 
				padding: '20px 25px',
				zIndex: 10,
				position: 'relative',
				height: '84px',
				flexShrink: 0,
        marginBottom:"4vh"
			}}>
				<Button
					variant="filled"
					onClick={handleBack}
					styles={{
						root: {
							backgroundColor: colors.buttonColor,
							color: colors.white,
							border: 'none',
							borderRadius: '8px',
							padding: '8px 20px',
							fontWeight: 'bold',
							minHeight: '44px',
							fontSize: fontSize.lg,
						}
					}}
				>
					Back
				</Button>
				
				{/* Empty space for balance */}
				<div style={{ width: '80px' }}></div>
			</Group>

			{/* Main Content Area - Style Options */}
			<Box 
				style={{ 
					height: '57vh',
          width: '80vw',
          marginLeft: '8.5vw',
					minHeight: 0,
					position: 'relative',
					display: 'flex',
					flexDirection: 'column',
          
				}}
        p="0px"
			>
				{/* Style Options Grid */}
				<Box style={{
					flex: 1,
					display: 'grid',
					gridTemplateColumns: '1fr 1fr',
					gridTemplateRows: '1fr 1fr',
					gap: '1.5vh 4vw',
				}}>
					{styleOptions.map((option) => (
						<Button
							key={option.id}
							variant="filled"
							onClick={() => handleSelectStyle(option.id)}
							styles={{
								root: {
									backgroundColor: colors.green,
									border: `5px solid ${colors.white}`,
									borderRadius: '10px',
									height: '100%',
									width: '37vw',
									justifyContent: 'space-between',
									padding: '0px',
									transition: 'all 0.3s ease'
								}
							}}
						>
							<Stack 
								align="stretch" 
								justify="space-between" 
								gap="15px"
								styles={{
                   root: {
                     width: '100%',
                     height: '100%',
                     padding:"0px",
                     margin:"0px"
                   }, 
								}}
							>
								{/* Blank space above image for centering */}
								<Box style={{
									flex: 1,
									width: '100%',
									margin: '0px',
									padding: '0px'
								}}></Box>
								
								{/* Style Image */}
								<Box style={{
									width: '100%',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									margin: '0px',
									padding: '0px',
									borderRadius: '5px'
								}}>
									<img
										src={option.image}
										alt={option.name}
										style={{ 
											width: '100%', 
											height: 'auto',
											objectFit: 'cover',
											borderTop: '5px solid white',
											borderBottom: '5px solid white',
											borderLeft: 'none',
											borderRight: 'none'
										}}
									/>
								</Box>
								
								{/* Style Name */}
								<Text style={{
                  flex: 1,
									fontSize: fontSize.lg,
									fontWeight: 'bold',
									color: colors.white,
									textAlign: 'center'
								}}>
									{option.name}
								</Text>
							</Stack>
						</Button>
					))}
				</Box>
			</Box>
		</Box>
	);
};

StyleSelectorMobile.propTypes = {
	// State
	selectedStyle: PropTypes.string,
	
	// Handle functions
	handleBack: PropTypes.func.isRequired,
	handleSelectStyle: PropTypes.func.isRequired
};

export default StyleSelectorMobile;
